import {
	Drawer,
	DrawerBody,
	DrawerHeader,
	DrawerOverlay,
	DrawerContent,
	DrawerCloseButton,
	Flex,
	Input,
	InputGroup,
	InputRightElement,
	List,
	ListItem,
	Icon,
	Text,
} from '@chakra-ui/react'
import { MdSearch } from 'react-icons/md'
import { useQuery } from 'react-query'
import { searchOrgContactsQueryKey } from '../../utils/queryKeyFactory'
import React, { useState } from 'react'
import { searchOrgContactsQuery } from '../../hooks/activity.hooks'
import { useLanguageContext } from '../../context/locale.context'
import { debounce } from 'lodash'
import { PropTypes } from 'prop-types'

const WhatNextDelegateSearch = ({ onClose, isOpen, delegateToUser }) => {
	const [searchQuery, setSearchQuery] = useState('')

	const {
		state: { locale },
	} = useLanguageContext()

	const searchOrgContactsParam = {
		search_string: searchQuery,
		limit_value: 50,
	}

	const { data: orgContactsData } = useQuery(
		searchOrgContactsQueryKey.search_string_param(searchOrgContactsParam),
		() => searchOrgContactsQuery(searchOrgContactsParam)
	)

	const onDebounceSearch = debounce(e => {
		setSearchQuery(e.target.value)
	}, 500)

	return (
		<>
			<Drawer isOpen={isOpen} placement='right' onClose={onClose} size='sm'>
				<DrawerOverlay />
				<DrawerContent>
					<DrawerCloseButton color='red.600' />
					<DrawerHeader>{locale['Search user...']}</DrawerHeader>

					<DrawerBody>
						<Flex flexDirection='column' h='100%'>
							<InputGroup w='full'>
								<Input
									bg='white'
									placeholder={`${locale['Enter user name']}...`}
									onChange={e => {
										onDebounceSearch(e)
										setSearchQuery(e.target.value)
									}}
									_focus={{
										border: 'none',
									}}
									border='1px solid #D9D9D9'
									borderRadius='20px'
									value={searchQuery}
									_placeholder={{
										color: 'gray.400',
										fontWeight: '400',
										fontSize: '0.875rem',
									}}
								/>
								<InputRightElement
									children={
										<Icon as={MdSearch} color='green.700' w={6} h={6} />
									}
								/>
							</InputGroup>
							<List w='full' h='90%' overflowY='auto'>
								{orgContactsData?.length === 0 ? (
									<Text fontSize='0.875rem' fontWeight='500' mt='1rem'>
										{locale['No records found']}
									</Text>
								) : (
									(orgContactsData || []).map(contact => {
										const { contact_operating_asset_name } = contact
										return (
											<React.Fragment key={contact.contact_asset_id}>
												<ListItem
													py='1rem'
													borderBottom='1px solid #E1E1E1'
													cursor='pointer'
													onClick={() => delegateToUser(contact)}
												>
													<Text
														color='brand.700'
														fontSize='1rem'
														fontWeight='500'
														textTransform='capitalize'
													>
														{contact_operating_asset_name}
													</Text>
												</ListItem>
											</React.Fragment>
										)
									})
								)}
							</List>
						</Flex>
					</DrawerBody>
				</DrawerContent>
			</Drawer>
		</>
	)
}

WhatNextDelegateSearch.propTypes = {
	onClose: PropTypes.func.isRequired,
	isOpen: PropTypes.bool.isRequired,
	delegateToUser: PropTypes.func.isRequired,
}

export { WhatNextDelegateSearch }
